// JS Dependencies: Bootstrap & JQuery
// Register what bootstrap modules we need here, add a comment so we know where it is used
// Collapse is used for the Panels Editor
import Collapse from 'bootstrap/js/dist/collapse';
import Tab from 'bootstrap/js/dist/tab';
import DropDown from 'bootstrap/js/dist/dropdown';  // For the dropdown on the News Page (Archives) -MR
import Carousel from 'bootstrap/js/dist/carousel';

// CSS Dependencies: Bootstrap
import 'bootstrap-icons/bootstrap-icons.svg';
import "bootstrap-icons/font/bootstrap-icons.css";

// Custom JS imports
import '../map-viewer/map-viewer';

// Custom CSS imports
import '../css/site.scss';

console.log('The \'site\' bundle has been loaded!');